__turbopack_context__.v({
  "accordionArrow": "Common-module__GNwwAG__accordionArrow",
  "customScrollbar": "Common-module__GNwwAG__customScrollbar",
  "scrollbarHide": "Common-module__GNwwAG__scrollbarHide",
  "summaryReset": "Common-module__GNwwAG__summaryReset",
});
